import { useEffect, useState } from "react";
import frFR from "antd/locale/fr_FR";
import {
    Button,
    Card,
    Input,
    Select,
    Checkbox,
    Typography,
    Space,
    Row,
    Col,
    Tree,
    Modal,
    ConfigProvider,
} from "antd";
import {
    PlusOutlined,
    UploadOutlined,
    DownloadOutlined,
    FolderOpenOutlined,
    FolderOutlined,
    FileTextOutlined,
    ExpandOutlined,
    FilterOutlined,
} from "@ant-design/icons";
import axiosInstance from "../../../variables/api/axiosInstance";
import { toast } from "react-toastify";

const { Title, Text } = Typography;
const { Option } = Select;

const treeData = [
    {
        title: (
            <span>
                <FolderOpenOutlined style={{ color: "#1890ff", marginRight: 8 }} />
                Classe 1 - Comptes de capitaux
            </span>
        ),
        key: "1",
        children: [
            {
                title: (
                    <span>
                        <FileTextOutlined style={{ marginRight: 8 }} />101 - Capital social
                    </span>
                ),
                key: "1-1",
            },
            {
                title: (
                    <span>
                        <FileTextOutlined style={{ marginRight: 8 }} />106 - Réserves
                    </span>
                ),
                key: "1-2",
            },
        ],
    },
    {
        title: (
            <span>
                <FolderOutlined style={{ marginRight: 8 }} />Classe 2 - Comptes d'immobilisations
            </span>
        ),
        key: "2",
    },
    {
        title: (
            <span>
                <FolderOutlined style={{ marginRight: 8 }} />Classe 3 - Comptes de stocks
            </span>
        ),
        key: "3",
    },
    {
        title: (
            <span>
                <FolderOpenOutlined style={{ color: "#1890ff", marginRight: 8 }} />Classe 4 - Comptes de tiers
            </span>
        ),
        key: "4",
        children: [
            {
                title: (
                    <span>
                        <FileTextOutlined style={{ marginRight: 8 }} />401 - Fournisseurs
                    </span>
                ),
                key: "4-1",
            },
            {
                title: (
                    <span>
                        <FileTextOutlined style={{ marginRight: 8 }} />411 - Clients
                    </span>
                ),
                key: "4-2",
            },
            {
                title: (
                    <span>
                        <FileTextOutlined style={{ marginRight: 8 }} />421 - Personnel
                    </span>
                ),
                key: "4-3",
            },
        ],
    },
    {
        title: (
            <span>
                <FolderOutlined style={{ marginRight: 8 }} />Classe 5 - Comptes financiers
            </span>
        ),
        key: "5",
    },
    {
        title: (
            <span>
                <FolderOutlined style={{ marginRight: 8 }} />Classe 6 - Comptes de charges
            </span>
        ),
        key: "6",
    },
    {
        title: (
            <span>
                <FolderOutlined style={{ marginRight: 8 }} />Classe 7 - Comptes de produits
            </span>
        ),
        key: "7",
    },
];

const PlanComptable = () => {
    const [openClasseComptableModal, setOpenClasseComptableModal] = useState(false);
    const [nom, setNom] = useState("");
    const [commentaire, setCommentaire] = useState("");
    const [ordre, setOrdre] = useState(0);
    const [loading, setLoading] = useState(false);
    const [classes, setClasses] = useState([]);
    const [treeDataState, setTreeDataState] = useState(treeData);
    const [editCompteMode, setEditCompteMode] = useState(false);
    // Les champs du formulaire d'ajout de compte
    const [classeComptable, setClasseComptable] = useState("");
    const [numeroCompte, setNumeroCompte] = useState("");
    const [intitule, setIntitule] = useState("");
    const [description, setDescription] = useState("");
    const [compteParent, setCompteParent] = useState("");
    const [reconciliable, setReconciliable] = useState(true);
    //
    const [existingCompte, setExistingCompte] = useState(null);

    useEffect(() => {
        axiosInstance
            .get('/api/classe-comptable')
            .then((res) => {
                const classesData = res?.data?.map(item => ({
                    title: (
                        <span style={{ marginLeft: 0 }}>
                            <FolderOpenOutlined style={{ color: "#1890ff", marginRight: 8 }} />
                            {item?.code} - {item?.intitule}
                        </span>
                    ),
                    key: item?.classeComptableId,
                    children: item?.comptes && item?.comptes.length > 0 ? item?.comptes?.map(compte => ({
                        title: (
                            <span onClick={() => {
                                setEditCompteMode(compte?.compteComptableId);
                                setClasseComptable(JSON.stringify(item));
                                setNumeroCompte(compte?.numero);
                                setIntitule(compte?.intitule);
                                setDescription(compte?.description);
                                setCompteParent(compte?.parent ? JSON.stringify(compte?.parent) : "");
                                setReconciliable(compte?.reconciliable);
                            }}>
                                <FileTextOutlined style={{ marginRight: 8 }} />
                                {compte?.numero} - {compte?.intitule}
                            </span>
                        ),
                        key: `${item?.classeComptableId}-${compte?.compteComptableId}`,
                    })) : null,
                }));
                setClasses(res.data);
                setTreeDataState(classesData);
            })
            .catch((err) => {
                console.error("Error fetching classes:", err);
            });
    }, []);

    const handleAddClasse = () => {
        setLoading(true);
        // Logic to add a new class
        axiosInstance.post('/api/classe-comptable', {
            code: nom,
            intitule: commentaire,
            ordre: parseInt(ordre)
        })
            .then((res) => {
                console.log("Class added successfully:", res.data);
                toast.success("Classe comptable ajoutée avec succès !");
                // Optionally, refresh the tree data or update state to reflect the new class
                handleCancel();
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error adding class:", err);
                setLoading(false);
            });
    };

    const handleCancel = () => {
        setOpenClasseComptableModal(false);
        setNom("");
        setCommentaire("");
        setOrdre(0);
    };

    const handleCancelCompteComptable = () => {
        setEditCompteMode(false);
        setClasseComptable("");
        setNumeroCompte("");
        setIntitule("");
        setDescription("");
        setCompteParent("");
        setReconciliable(true);
    };

    const handleSubmitCompte = () => {
        if (!classeComptable || !numeroCompte || !intitule) {
            toast.error("Veuillez remplir tous les champs obligatoires.");
            return;
        }
        if (existingCompte) {
            toast.error("Un compte avec ce numéro existe déjà.");
            return;
        }
        setLoading(true);
        const classe = JSON.parse(classeComptable);
        const compteData = {
            classeComptable: classe,
            numero: parseInt(numeroCompte),
            intitule: intitule,
            description: description,
            parent: compteParent ? JSON.parse(compteParent) : null,
            reconciliable: reconciliable,
        };

        console.log("Compte Data:", compteData);
        if (editCompteMode) {
            compteData.compteComptableId = editCompteMode; // Assuming editCompteMode holds the ID of the account being edited
            // Logic to update an existing account
            axiosInstance.put(`/api/compte-comptable`, compteData)
                .then((res) => {
                    console.log("Compte updated successfully:", res.data);
                    toast.success("Compte mis à jour avec succès !");
                    // Optionally, refresh the tree data or update state to reflect the updated account
                    handleCancelCompteComptable();
                    setLoading(false);

                    window.location.reload();
                })
                .catch((err) => {
                    console.error("Error updating account:", err);
                    setLoading(false);
                });
        } else {
            axiosInstance.post('/api/compte-comptable', compteData)
                .then((res) => {
                    console.log("Compte added successfully:", res.data);
                    toast.success("Compte ajouté avec succès !");
                    // Optionally, refresh the tree data or update state to reflect the new class
                    handleCancelCompteComptable();
                    setLoading(false);

                    window.location.reload();
                })
                .catch((err) => {
                    console.error("Error adding class:", err);
                    setLoading(false);
                });
        }
    }

    const checkCompteExists = (value) => {
        axiosInstance.get(`/api/compte-comptable/numero/${value}`)
            .then((res) => {
                if (res.data) {
                    setExistingCompte(true);
                    toast.error("Le compte existe deja!");
                } else {
                    setExistingCompte(false);
                }
            })
            .catch((err) => {
                console.error("Checking account:", err);
            });
    }

    return (
        <div className="p-6">
            <ConfigProvider locale={frFR}>
                <Card className="shadow-sm">
                    <Row justify="space-between" align="middle" style={{ marginBottom: 24 }}>
                        <Title className="text-xl font-semibold mb-4" style={{ color: '#2D2D2D' }} level={4}>Plan Comptable</Title>
                        <Space>
                            <Button type="primary" icon={<PlusOutlined />}>Nouveau Compte</Button>
                            <Button icon={<UploadOutlined />}>Importer</Button>
                            <Button icon={<DownloadOutlined />}>Exporter</Button>
                        </Space>
                    </Row>
                    <p style={{ color: '#666' }}>Gérez votre plan comptable ici...</p>

                    <Row gutter={24}>
                        <Col xs={24} lg={6}>
                            <Card title="Arborescence" extra={<Space><ExpandOutlined /><FilterOutlined /></Space>}>
                                <Tree treeData={treeDataState} defaultExpandAll />
                            </Card>
                            <Button
                                type="dashed"
                                style={{ width: "100%", marginTop: 16, backgroundColor: "#272366", color: "white" }}
                                onClick={() => setOpenClasseComptableModal(true)}
                            >
                                <PlusOutlined /> Ajouter une classe comptable
                            </Button>
                        </Col>

                        <Col xs={24} lg={18}>
                            <Card title={editCompteMode ? "Détails du Compte" : "Ajouter un Compte"}>
                                <Row gutter={16}>
                                    <Col xs={24} md={12}>
                                        <Text>Classe comptable*</Text>
                                        <Select placeholder="Selectionner la classe comptable" value={classeComptable} onChange={(e) => setClasseComptable(e)} style={{ width: "100%" }}>
                                            {classes.map((classe) => (
                                                <Option key={classe.classeComptableId} value={JSON.stringify(classe)}>
                                                    {classe.ordre} - {classe.intitule}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Text>Numéro de compte*</Text>
                                        <Input value={numeroCompte} onChange={(e) => { setNumeroCompte(e.target.value); checkCompteExists(e.target.value); }} />
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Text>Intitulé*</Text>
                                        <Input value={intitule} onChange={(e) => setIntitule(e.target.value)} />
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Text>Compte parent</Text>
                                        <Select value={compteParent} onChange={(e) => setCompteParent(e)} style={{ width: "100%" }}>
                                            {classeComptable ? JSON.parse(classeComptable)?.comptes?.map((compte) => (
                                                <Option key={compte.id} value={JSON.stringify(compte)}>
                                                    {compte.code} - {compte.intitule}
                                                </Option>
                                            )) : null}
                                        </Select>
                                    </Col>
                                </Row>
                                <div style={{ marginTop: 15 }}>
                                    <Text>Description</Text>
                                    <Input.TextArea value={description} onChange={(e) => setDescription(e.target.value)} rows={3} />
                                </div>
                                <Row justify="space-between" align="middle" style={{ marginTop: 24 }}>
                                    <Checkbox checked={reconciliable} onChange={(e) => setReconciliable(e.target.checked)}>Compte réconciliable</Checkbox>
                                    <Space>
                                        <Button onClick={handleCancelCompteComptable}>Annuler</Button>
                                        <Button loading={loading} onClick={handleSubmitCompte} type="primary">Enregistrer</Button>
                                    </Space>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                </Card>

                <Modal
                    title="Ajouter une classe comptable"
                    open={openClasseComptableModal}
                    onOk={handleAddClasse}
                    onCancel={handleCancel}
                    loading={loading}
                    okText="Ajouter"
                    cancelText="Annuler"
                >
                    <div className="row">
                        <div className="col-8">
                            <div class="mb-3">
                                <label for="nom" class="form-label">Nom de la classe</label>
                                <input type="text" class="form-control" placeholder="Nom de la classe" id="nom" value={nom} onChange={(e) => setNom(e.target.value)} />
                            </div>
                        </div>
                        <div className="col-4">
                            <div class="mb-3">
                                <label for="nom" class="form-label">Ordre</label>
                                <input type="number" class="form-control" placeholder="Ordre" id="ordre" value={ordre} onChange={(e) => setOrdre(e.target.value)} />
                            </div>
                        </div>
                        <div class="col-12 mb-3">
                            <label for="commentaire" class="form-label">Intitulé</label>
                            <input
                                class="form-control"
                                id="commentaire"
                                type="text"
                                placeholder="Intitulé de la classe"
                                value={commentaire}
                                onChange={(e) => setCommentaire(e.target.value)}
                            />
                        </div>
                    </div>


                </Modal>
            </ConfigProvider>
        </div>
    );
};

export default PlanComptable;
